import type { UniversalCamera } from "@babylonjs/core";
import type { CameraParams } from "../state/settings";

/**
 * Applies the person's look settings (spec 2g §3.2). Vertical look goes through the camera's input map:
 * Babylon's mouse input prefers a pointer "rotate" entry's sensitivityY over 1 / angularSensibility, so a
 * negative value inverts Y without touching horizontal look.
 */
export function applyCamera(cam: UniversalCamera, p: CameraParams): void {
  cam.angularSensibility = p.angularSensibility;
  cam.fov = p.fovRad;
  for (const entry of cam.movement.input.getEntries("pointer", "rotate")) entry.sensitivityY = p.sensitivityY;
}
